import styled, { css } from 'styled-components'

interface ICarouselProps {
  currentSlide: number
}

export const CarouselScroll = styled.div<ICarouselProps>`
  display: flex;
  justify-content: start;
  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    transition: all 0.3s ease-out;
    & > div {
      opacity: 0;
      transition: all 0.3s ease-in;
    }
    ${({ currentSlide }) =>
      currentSlide >= 0 &&
      css`
        transform: translateX(-${currentSlide * 100}vw);
        transition: all 0.3s ease-in 0.1s;

        div:nth-child(${currentSlide + 1}) {
          opacity: 1;
          transition: all 0.3s ease-in;
        }
      `};
  }
`

export const CarouselControl = styled.div`
  display: flex;
  position: absolute;
  top: 220px;
  z-index: 2;
  width: 90vw;
  justify-content: space-between;
  align-items: center;
  left: 5vw;
`
export const CarouselCounter = styled.ul`
  list-style: none;
  display: inline-block;
`
export const CarouselCounterItem = styled.li<{ active: boolean }>`
  width: ${(props) => (props.active ? '32px' : '6px')};
  height: 6px;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  background-color: ${({ theme }) => theme.color.border.neutral.medium};
  display: inline-block;
  transition: all 0.5s ease;

  & + li {
    margin-left: ${({ theme }) => theme.spacing.km2};
  }
`
